import { toHeaderCase } from 'js-convert-case'

import { ErrorsBadge } from 'components/Error/ErrorsBadge'
import { Badge, BadgeProps } from 'ui-kit/badge'

import { WorkspaceElementStateDot } from './WorkspaceElementStateDot'

import { WORKSPACE_ELEMENT_STATE_TO_COLOR_PALETTE } from '.'

export function WorkspaceElementStateBadge({
  element,
  ...props
}: {
  element: any
} & BadgeProps) {
  const hasErrors = element.errors?.length > 0
  const errMessage =
    element.errors?.length === 1 ? 'Error' : `${element.errors?.length} errors`

  if (hasErrors) {
    return (
      <ErrorsBadge
        title={errMessage}
        errors={element.errors}
        variant='subtle'
        useStatusDot
        usePortal
        {...props}
      />
    )
  }
  if (element.state) {
    return (
      <Badge
        colorPalette={WORKSPACE_ELEMENT_STATE_TO_COLOR_PALETTE(element.state)}
        variant='subtle'
        {...props}
      >
        <WorkspaceElementStateDot state={element.state} />
        {toHeaderCase(element.state)}
      </Badge>
    )
  }
  return null
}
